import http from "../../utils/httpClient";

class addressService {
    getAddressById = async (id) => {
        return await http.get(`/api/Customer/GetAddress?customerAddressId=${id}`);
    };

    getAllCountry = async () => {
        return await http.get("/api/DivisionCitiesArea/AllCountries?getAll=Y");
    };

    getAllCity = async (query) => {
        return await http.get(`/api/DivisionCitiesArea/AllCities`, { params: query });
    };

    getAllArea = async (cityId) => {
        return await http.get(`/api/DivisionCitiesArea/AllAreas?cityId=${cityId}&getAll=Y&status=Y`);
    };

    getArea = async (query) => {
        return await http.get(`/api/DivisionCitiesArea/GetArea`, { params: query });
    };
}

export default new addressService();
